// extracted by mini-css-extract-plugin
module.exports = {"root":"Badge_root__Y_2tw","organicBadge":"Badge_organicBadge__o3_D0","interactive":"Badge_interactive__2KLw2","glitch":"Badge_glitch__y9ebZ"};